<template>
<div class="featured-dorms section">
    <div class="vld-parent mycenter">
      <loading :active.sync="isLoading" 
      :is-full-page="fullPage"></loading>
    </div> 
  <container>
    <div class="section__header mycenter">
      <div class="section__title">
        <span class="color-pink">En Popüler</span> Yurtlar
      </div>
      <div class="section__right">
        <!--<div v-for="(city,index) in cities" :key="city.id">-->
          <!--<SubpageCategory :links="city" @click.native="handleClickNavItem(index)" :class="{active : index===currentNav}" class="DesktopTab"/>-->
        <!--</div>-->
<!--         <div class="subpage-nav__list DesktopTab">
          <div class="subpage-nav__item" v-if="currentNav !== null">
            <button class="subpage-nav__link" @click="clearFilter">
              <span class="button__wrp">
                <span class="btn-txt">
                  Tümünü Gör
                </span>
              </span>
            </button>
          </div>
        </div> -->

        <div class="mobileTab">
          <select-box :options="cities" title="Şehir Seçiniz"/>
        </div>

        <!--<div class="mobileTab">-->
          <!--<select-box :options="linkMobile" title="İl Seçiniz"/>-->
        <!--</div>-->
      </div>
    </div>
      <ContentLoader v-if="!dorms && !mobileCheck"
      :height="900">
        <rect x="3" y="0" rx="3" ry="3" width="94" height="110" />
        <rect x="103" y="0" rx="3" ry="3" width="94" height="110" />
        <rect x="203" y="0" rx="3" ry="3" width="94" height="110" />
        <rect x="305" y="0" rx="3" ry="3" width="94" height="110" />
        
        <rect x="3" y="115" rx="3" ry="3" width="94" height="110" />
        <rect x="103" y="115" rx="3" ry="3" width="94" height="110" />
        <rect x="203" y="115" rx="3" ry="3" width="94" height="110" />
        <rect x="305" y="115" rx="3" ry="3" width="94" height="110" />        
      </ContentLoader>
      <ContentLoader v-if="!dorms && mobileCheck">
        <rect x="3" y="0" rx="3" ry="3" width="94" height="110" />      
      </ContentLoader>      
    <div class="featured-dorms__cnt">
      <div class="featured-dorms__list dorm-card__list">
        <swiper :options="swiperOption" style="display: none">
          <swiper-slide
            v-for="dorm in dorms"
            :key="dorm.id"
            class="featured-dorms__col col-xl-3 col-lg-3 col-md-4">
            <dorm-card
              :dorm="dorm"
            />
          </swiper-slide>
          <div class="swiper-paginations" style="text-align: center;" slot="pagination"></div>
        </swiper>
        <div
          v-for="dorm in dorms"
          :key="dorm.id"
          class="featured-dorms__col desktop-dorm col-xl-3 col-lg-3 col-md-4">
          <dorm-card
            :dorm="dorm"
          />
        </div>

        <empty-content :content="emptyContent" v-if="dorms && dorms.length === 0"/>
      </div>


    </div>

  </container>
</div>
</template>

<script>
import DormCard from '@/components/DormCard'
import SubpageCategory from '@/components/SubpageCategory'
import SelectBox from '@/components/SelectBox'
import EmptyContent from '@/components/EmptyContent'
import { ContentLoader } from 'vue-content-loader'
import axios from 'axios'

export default {
  name: 'FeaturedDormsNoTabs',
  components: {
    EmptyContent,
    DormCard,
    SelectBox,
    ContentLoader
  },
  data () {
    return {
      isLoading: false,
      fullPage: true,       
      currentNav: null,
      dorms: null,
      swiperOption: {
        slidesPerView: 2,
        spaceBetween: 20,
        slidesPerGroup: 2,
        breakpoints: {
          640: {
            slidesPerView: 'auto',
            centeredSlides: 'center',
            slidesPerGroup: 1
          },
          320: {
            slidesPerView: 'auto',
            centeredSlides: false,
            slidesPerGroup: 1

          }
        },
        pagination: {
          el: '.swiper-paginations',
          clickable: true
        }
      },
      cities: [],
/*       linkMobile: [
        {
          name: 'İstanbul'
        },
        {
          name: 'Ankara'
        },
        {
          name: 'Sakarya'
        },
        {
          name: 'İzmir'
        },
        {
          name: 'Afyon'
        }

      ], */
      emptyContent: {
        icon: 'icon-search',
        title: 'Sonuç Bulunamadı!',
        text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda dolor, dolorem fugit in quis velit!'
      },
      mainDorms: []
    }
  },
  methods: {
    getDorms () {
      let self = this
      this.isLoading = true
      axios.get('/site/home/showcase-promote-dorms')
        .then(response => {
          this.isLoading = false
          self.dorms = response.data.dorms
          self.mainDorms = response.data.dorms
          self.cities = response.data.cities
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
  },
  created () {
    this.getDorms()
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/components/featured-dorms";

.mycenter {
 display:table;
 margin:0 auto;
}
</style>
